<!--suppress ALL -->
<!--suppress ALL -->
<template>
  <detailTemplate
    :classCustom="[tabHistory ? 'detailShowHistory' : '', 'detail-docs']"
  >
    <template #content>
      <transition name="el-fade-in-linear">
        <el-tooltip content="Lịch sử tác động" placement="left">
          <div
            v-show="!tabHistory"
            class="btn-show-history clickable flex-row flex__center border-radius__50"
            @click="openTabHistory"
          >
            <el-badge class="inline-flex" is-dot>
              <i class="icon-small fal fa-comment-alt-smile"></i>
            </el-badge>
          </div>
        </el-tooltip>
      </transition>
      <i
        class="back-icon border-radius fal fa-arrow-right"
        @click="backListPage"
      ></i>
      <div class="header">
        <div class="docTags">
          <el-tag
            v-if="outgoingDoc.docTypeName"
            class="priority lv3"
            size="mini"
          >
            {{ outgoingDoc.docTypeName }}
          </el-tag>
          <el-tag
            v-if="outgoingDoc.priorityId"
            :class="['priority', `${getPriorityClass(outgoingDoc.priorityId)}`]"
            size="mini"
          >
            <i class="fas fa-bolt"></i>
            {{ outgoingDoc.priorityName }}
          </el-tag>
        </div>
        <h4 class="title-name">
          {{ outgoingDoc.quote }}
        </h4>

        <!--        phan mo dialog ghi chu van ban-->
        <!-- Thẻ 1: Hiển thị khi ở màn hình choXuLy() -->
        <div v-if="isChoXuLy()">
          <!--     Hiển thị file đã được upload     -->
          <div
            class="file-uploaded margin-top-10"
            v-if="isChoXuLy() && (vbAttachment ||
                   (roleCode != 'vanthu' || userVbOutgoingProcessId) && attachmentMetadata && !isViewAsUyQuyen)
                   "
          >
            <div class="file clickable flex-row flex__between padding-left-10">
              <div @click="openDocument(vbAttachment)">
                <file-type-image
                  :custom-class="'icon-small margin-right-10'"
                  :file-extention="(() => {
                          const ext = vbAttachment.fileName.split('.').pop().toLowerCase();
                          if (ext === 'doc' || ext === 'docx') {
                              return 'doc';
                          } else if (ext === 'pdf') {
                              return 'pdf';
                          } else {
                              return 'unknown';
                          }
                      })()"
                ></file-type-image>
                <span class="fileName font-weight_normal color__white"
                      style="border-bottom: 1px dashed;
                                line-height: initial;
                                display: inline-block; max-width: 200px;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                 vertical-align: middle;"
                >
                  {{ vbAttachment.fileName }}
                </span>
              </div>
              <div v-if="!(vbAttachment.fileName.split('.').pop().toLowerCase() === 'pdf' && vbAttachment.isSigned === DA_KY)">
                <i
                  class="el-icon-circle-close margin-left-10 font-size__large color__red"
                  @click="removeUploadAttachment"
                ></i>
              </div>
            </div>
          </div>

          <!--     Nếu chưa có file được upload thì cho phép upload     -->
          <!-- Thẻ 2: Hiển thị khi người dùng ấn button xóa -->
          <el-form v-else ref="fileForm">
            <el-form-item class="input-no__label">
              <el-upload
                class="upload-demo style-fullWidth input-border__bottom"
                :action="uploadAttachmentURL"
                size=""
                :on-success="
                        response =>
                          onUploadSuccess(response).then(response =>
                            uploadAttachmentSuccess(response)
                          )
                      "
                :data="uploadAttachmentAdditionalData"
                :headers="uploadAttachmentHeaders"
                :show-file-list="false"
                :before-upload="
                        file =>
                          newValidateUploadFile(
                            file,
                            {
                              acceptFileTypes: 'application/pdf,' +
                               'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                            },
                            buildMessageUploadOnlyPdf()
                          )
                      "
                :on-error="onUploadError"
                :on-change="() => (isUploadingDocFlag = true)"
                v-loading="isUploadingDocFlag  && isUploading"
              >
                <div class="el-upload__text">
                  <p class="margin-0 padding-0">
                    Tải file đính kèm
                    <span class="font-italic font-size__small color__red">{{"(Định dạng file pdf,docx)"}}</span>
                  </p>
                  <i class="fas fa-cloud-upload color__blue font-size__large"></i>
                </div>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>

        <!-- Thẻ 3: Hiển thị khi không ở màn hình choXuLy() -->
        <vbdi-download-files
          v-else
          :docId="id"
          :userDeptRoleId="userDeptRoleId"
        ></vbdi-download-files>
        <div v-if="!globalConfigEditNode" class="flex-row margin-bottom-10">
          <el-button v-if="vbAttachment&&vbAttachment.id" class="btnPlain"
                     @click="isOpenVbDiVersionDialog = true">
            <i class="fas fa-history"></i>
            &nbsp;Phiên bản văn bản dự thảo
          </el-button>
        </div>
        <div v-if="globalConfigEditNode" class="flex-row margin-bottom-10">
          <el-button v-if="vbAttachment&&vbAttachment.id" class="btnPlain"
                     @click="isOpenVbDiVersionLanhDaoEditDialog = true">
            <i class="fas fa-history"></i>
            &nbsp;Phiên bản văn bản dự thảo
          </el-button>
        </div>
      </div>

      <VuePerfectScrollbar :settings="settings" class="scroll-area">
        <div class="body">
          <div class="group__info margin-top-10 padding-bottom-10">
            <div class="title font-size__medium">Thông tin</div>
            <div class="ctn">
              <div class="list-info width__100">
                <div
                  v-if="outgoingDoc.docCode"
                  class="item flex-row flex__left margin-bottom-10"
                >
                  <div class="label font-size__small txt-right">
                    Số ký hiệu:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ outgoingDoc.docCode || "-" }}
                  </div>
                </div>
                <div
                  v-if="outgoingDoc.docDate"
                  class="item flex-row flex__left margin-bottom-10"
                >
                  <div class="label font-size__small txt-right">
                    Ngày văn bản:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{
                      outgoingDoc.docDate
                        | dateFormatter({
                        nullValue: "-",
                        dateFormat: "DD/MM/YYYY"
                      })
                    }}
                  </div>
                </div>

                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Hạn xử lý:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{
                      outgoingDoc.deadlineDate
                        | dateFormatter({
                        nullValue: "-",
                        dateFormat: "DD/MM/YYYY HH:mm"
                      })
                    }}
                  </div>
                </div>

                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Đơn vị ban hành:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{outgoingDoc.publisherNameDetail}}
                    {{ outgoingDoc.publisherName || "-" }}
                  </div>
                </div>

                <div
                  v-if="
                    docStatus === OUTGOING_DOC_STATUS.CHO_BAN_HANH ||
                      docStatus === OUTGOING_DOC_STATUS.DABANHANH
                  "
                  class="item flex-row flex__left margin-bottom-10"
                >
                  <div class="label font-size__small txt-right">
                    Người ký duyệt:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ signerName || "-" }}
                  </div>
                </div>

                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Đơn vị thực hiện:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ outgoingDoc.deptEditorName || "-" }}
                  </div>
                </div>

                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Số trang/ Số bản:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ outgoingDoc.numberOfPage || "-" }} /
                    {{ outgoingDoc.numberOfCopy || "-" }}
                  </div>
                </div>

                <!--nơi nhận bên trong-->
                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Nơi nhận bên trong:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    <p v-if="!docReceivers || !docReceivers.length">-</p>
                    <div v-else class="flex-col flex__left">
                      <p
                        v-for="docReceiver in docReceivers"
                        v-bind:key="docReceiver.id"
                        :class="[
                          'index' !== docReceivers.length - 1
                            ? 'margin-bottom-10'
                            : ''
                        ]"
                      >
                        {{ docReceiver.objectName }}
                      </p>
                    </div>
                  </div>
                </div>
                <!--nơi nhận bên trong:end-->

                <!--nơi nhận bên ngoài-->
                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Nơi nhận bên ngoài:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    <!-- doi voi cac du lieu moi thi hien thi kieu nay-->
                    <div
                      v-if="receiveOtherDepts && receiveOtherDepts.length"
                      class="flex-col flex__left"
                    >
                      <p
                        v-for="receiveOtherDept in receiveOtherDepts"
                        :key="receiveOtherDept.id"
                        class="margin-bottom-10"
                      >
                        {{ receiveOtherDept.objectName }}
                      </p>
                    </div>
                    <!-- doi voi cac du lieu moi thi hien thi kieu nay:end-->
                    <!-- doi voi cac du lieu cu thi hien thi kieu nay-->
                    <div
                      v-else-if="outgoingDoc && outgoingDoc.otherReceivePlaces"
                      class="flex-col flex__left"
                    >
                      <p
                        v-for="otherReceivePlace in outgoingDoc.otherReceivePlaces.split(
                          ','
                        )"
                        :key="otherReceivePlace"
                        class="margin-bottom-10"
                      >
                        {{ otherReceivePlace || "-" }}
                      </p>
                    </div>
                    <!-- doi voi cac du lieu cu thi hien thi kieu nay:end-->
                    <p v-else class="txt__left">-</p>
                  </div>
                </div>
                <!--nơi nhận bên ngoài:end-->


<!--                <div v-if="-->
<!--                    docStatus === OUTGOING_DOC_STATUS.TU_CHOI ||-->
<!--                    docStatus === OUTGOING_DOC_STATUS.TU_CHOI_BAN_HANH-->
<!--                  " class="item flex-row flex__left margin-bottom-10">-->
<!--                  <div class="label font-size__small txt-right">-->
<!--                    Lý do từ chối:-->
<!--                  </div>-->
<!--                  <div class="content width__100 has-border__bottom">-->
<!--                    {{ receivedComment || "-" }}-->
<!--                  </div>-->
<!--                </div>-->

                <!--nơi nhận trên trục liên thông-->
                <div
                  v-if="isBanHanhTrucLienThong"
                  class="item flex-row flex__left margin-bottom-10"
                >
                  <div class="label font-size__small txt-right">
                    Nơi nhận trên trục liên thông văn bản
                  </div>
                  <div class="content width__100 has-border__bottom">
                    <p v-if="!agencies || !agencies.length">-</p>
                    <div v-else class="flex-col flex__left">
                      <p
                        v-for="agency in agencies"
                        v-bind:key="agency.id"
                        :class="[
                          'index' !== agencies.length - 1
                            ? 'margin-bottom-10'
                            : ''
                        ]"
                      >
                        {{ agency.objectName }}
                      </p>
                    </div>
                  </div>
                </div>
                <!--nơi nhận trên trục liên thông:end-->

                <div
                  v-if="isBanHanhTrucLienThong"
                  class="item flex-row flex__left margin-bottom-10"
                >
                  <div class="label font-size__small txt-right">
                    Văn bản quy phạm pháp luật
                  </div>
                  <div class="content width__100 has-border__bottom">
                    <el-checkbox
                      v-model="isLawDocument"
                      :border="false"
                      :disabled="true"
                      class="style-fullWidth"
                    ></el-checkbox>
                  </div>
                </div>

                <div
                  v-if="isBanHanhTrucLienThong"
                  class="item flex-row flex__left margin-bottom-10"
                >
                  <div class="label font-size__small txt-right">
                    Loại chỉ đạo
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ steeringTypeLabel || "-" }}
                  </div>
                </div>
                <div
                  v-if="isDaBanHanh"
                  class="item flex-row flex__left margin-bottom-10"
                >
                  <div class="label font-size__small txt-right">
                    Ban hành văn bản giấy:
                  </div>
                  <div class="content width__100">
                    <div class="flex-col flex__left">
                      <el-checkbox
                        v-model="isBanHanhBanGiay"
                        @change="confirmBanHanhBanGiay"
                        :disabled="isBanHanhBanGiay || roleCode != 'vanthu'"
                      />
                    </div>
                  </div>
                </div>
                <div
                  v-if="isDaBanHanh"
                  class="item flex-row flex__left margin-bottom-10"
                >
                  <div class="label font-size__small txt-right">
                    Không có tài liệu kèm:
                  </div>
                  <div class="content width__100">
                    <div class="flex-col flex__left">
                      <el-checkbox
                        v-model="isNotFileDinhKem"
                        @change= "confirmKhongCoFileDinhKem"
                        :disabled= "isNotFileDinhKem || roleCode != 'vanthu'"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <doc-relations-detail
            ref="docRelationsNoAttachedDetail"
            :attached-type="DOC_RELATION_ATTACHED_TYPE.NO_ATTACHED"
            :doc-id="id"
            :title="'Văn bản liên quan không ban hành kèm'"
          ></doc-relations-detail>

          <doc-relations-detail
            ref="docRelationsAttachedDetail"
            :attached-type="DOC_RELATION_ATTACHED_TYPE.ATTACHED"
            :doc-id="id"
            :title="'Văn bản liên quan ban hành kèm'"
          ></doc-relations-detail>

          <doc-relations-detail
            ref="docRelationsAttachedLinkDetail"
            :attached-type="DOC_RELATION_ATTACHED_TYPE.VB_LIEN_QUAN_LINK"
            :doc-id="id"
            :title="'Văn bản liên quan link tới văn bản hiện tại'"
          ></doc-relations-detail>

          <phieu-y-kien-detail
            :doc-id="id"
            :title="'Phiếu ý kiến'"
          ></phieu-y-kien-detail>

          <vbdi-luongxuly-wrapper :id="id"></vbdi-luongxuly-wrapper>
          <vbdi-luongxuly-all
            v-if="openFlowDetail"
            :docId="id"
            :openFlowDetail="openFlowDetail"
            @closeDialog="openFlowDetail=false"
          />
        </div>
      </VuePerfectScrollbar>

      <div v-if="!isAchievement" class="footer" style="overflow-x: scroll;">
        <div class="flex-row flex__left form-button__action">
          <!--          h start cây thư mục-->
          <el-button
            class="detailBtn detailBtnPrimary"
            @click="linkFolder"
          >
            <i class="fas fa-link"></i>
            Liên Kết Thư Mục
          </el-button>
          <!--          h end cây thư mục-->
          <el-button
            v-if="isEnableChuyenXuLi() && !isViewAsUyQuyen && isAssistantSign != 1"
            class="detailBtn detailBtnPrimary"
            @click="handleTransfer"
          >
            <i class="fas fa-arrow-alt-to-right font-size__small"></i>
            <span v-if="step == null || step.signType != 2"
            >&nbsp;Chuyển phê duyệt</span
            >
            <span v-else-if="step && step.signType == 2"
            >&nbsp;Ký số và Chuyển xử lý</span
            >
          </el-button>
          <el-button
            v-if="isEnableKetThuc() && !isViewAsUyQuyen && isAssistantSign != 1"
            class="detailBtn detailBtnSecondary"
            @click="handleApproval"
          >
            <i class="fas fa-check-circle font-size__small"></i>
            <span v-if="step == null || step.signType != 2"
            >&nbsp;Phê duyệt</span
            >
            <span v-else-if="step && step.signType == 2">&nbsp;Ký duyệt</span>
          </el-button>
          <el-button
            v-if="isAssistantSign != null && isAssistantSign == 1"
            class="detailBtn detailBtnPrimary"
            @click="isOpenDocOutSelectHandlerDialog = true"
          >
            <i class="fas fa-arrow-alt-to-right font-size__small"></i>
            <span v-if="step == null || step.signType != 2 || step.signType == 2 && roleCode !== LANH_DAO"
            >&nbsp;Chuyển xử lý</span
            >
            <span v-else-if="step && step.signType == 2 && roleCode === LANH_DAO">&nbsp;Ký số và Chuyển xử lý</span>
          </el-button>
          <el-button
            class="detailBtn detailBtnPrimary "
            @click="inPhieuTrinhKi"
            v-if="isViewTuChoi"
          >
            <i class="fas fa-print"></i>
            In phiếu xử lý
          </el-button>

          <el-button
            class="detailBtn detailBtnPrimary"
            @click="openFlowDetail = true"
          >
            <i class="fas fa-eye font-size__medium"></i>
            &nbsp;Phân luồng
          </el-button>

          <el-button
            v-if="isChoXuLy() && !isViewAsUyQuyen"
            class="detailBtn detailBtnAlert"
            @click="handleRejection"
          >
            <i class="fas fa-ban font-size__small"></i>
            &nbsp;Từ chối
          </el-button>

          <el-button
            v-if="isEnableTuChoiBanHanh()"
            class="detailBtn detailBtnAlert"
            @click="handleRejectionBanHanh"
          >
            <i class="fas fa-ban font-size__small"></i>
            &nbsp;Từ chối
          </el-button>

          <el-button
            v-if="canOutGoingProcessThuHoi && !isViewAsUyQuyen"
            class="detailBtn detailBtnSecondary"
            @click="isOpenOutgoingDocProcessThuHoiDialog = true"
          >
            <i class="fas fa-undo font-size__small"></i>
            &nbsp;Thu hồi
          </el-button>

          <el-button
            v-if="canOutoingDocThuHoi"
            class="detailBtn detailBtnSecondary"
            @click="isOpenOutgoingDocThuHoiDialog = true"
          >
            <i class="fas fa-undo font-size__small"></i>
            &nbsp;Thu hồi
          </el-button>

          <el-button
            v-if="canOutoingDocDBHThuHoi"
            class="detailBtn detailBtnSecondary"
            @click="isOpenOutgoingDocDBHThuHoiDialog = true"
          >
            <i class="fas fa-undo font-size__small"></i>
            &nbsp;Thu hồi
          </el-button>

          <el-button
            v-if="canOutGoingProcessThuHoiVinataba && !isViewAsUyQuyenVinataba  && (TuChoi()  || (isBanHanhToi() && isDocReceiversNull()) || (isSuaSai() && isNotTuChoiInList()) || (isSuaSai() && !isNotTuChoiInList() && isDocReceiversNull()) )"
            class="detailBtn detailBtnSecondary"
            @click="isOpenOutgoingDocProcessThuHoiDialog = true"
          >
            <i class="fas fa-undo font-size__small"></i>
            &nbsp;Thu hồi
          </el-button>

          <el-button
            v-if="canOutoingDocThuHoiVinataba && (TuChoi()  || (isBanHanhToi() && isDocReceiversNull()) || (isSuaSai() && isNotTuChoiInList()) || (isSuaSai() && !isNotTuChoiInList() && isDocReceiversNull()) )"
            class="detailBtn detailBtnSecondary"
            @click="isOpenOutgoingDocThuHoiDialog = true"
          >
            <i class="fas fa-undo font-size__small"></i>
            &nbsp;Thu hồi
          </el-button>

          <el-button
            v-if="canOutoingDocDBHThuHoiVinataba && (TuChoi()  || (isBanHanhToi() && isDocReceiversNull()) || (isSuaSai() && isNotTuChoiInList()) || (isSuaSai() && !isNotTuChoiInList() && isDocReceiversNull()) )"
            class="detailBtn detailBtnSecondary"
            @click="isOpenOutgoingDocDBHThuHoiDialog = true"
          >
            <i class="fas fa-undo font-size__small"></i>
            &nbsp;Thu hồi
          </el-button>

          <el-button
            v-if="isEnableBanHanhVinataba() && (TuChoi()  || (isBanHanhToi() && isDocReceiversNull()) || (isSuaSai() && isNotTuChoiInList()) || (isSuaSai() && !isNotTuChoiInList() && isDocReceiversNull()) )"
            class="detailBtn detailBtnPrimary"
            @click="isOpenBHanhDocOut = true"
          >
            <i class="fas fa-file-export font-size__small"></i>
            &nbsp;Ban hành
          </el-button>

          <el-button
            v-if="isEnableBanHanh()"
            class="detailBtn detailBtnPrimary"
            @click="isOpenBHanhDocOut = true"
          >
            <i class="fas fa-file-export font-size__small"></i>
            &nbsp;Ban hành
          </el-button>

          <el-button
            v-if="isEnableSuaSaiBanHanhVinataba() && (TuChoi()  || (isBanHanhToi() && isDocReceiversNull()) || (isSuaSai() && isNotTuChoiInList()) || (isSuaSai() && !isNotTuChoiInList() && isDocReceiversNull()) )"
            class="detailBtn detailBtnPrimary"
            @click="suaSaiBanHanh"
          >
            <i class="fas fa-check font-size__small"></i>
            Sửa sai
          </el-button>

          <el-button
            v-if="isEnableSuaSaiBanHanh()"
            class="detailBtn detailBtnPrimary"
            @click="suaSaiBanHanh"
          >
            <i class="fas fa-check font-size__small"></i>
            Sửa sai
          </el-button>

          <el-button
            v-if="isEnableHieuChinh()"
            class="detailBtn detailBtnPrimary"
            @click="hieuChinhVb()"
          >
            <i class="fas fa-file-export font-size__small"></i>
            &nbsp;Hiệu chỉnh & ban hành
          </el-button>

          <el-button
            v-if="isEnableDelete()"
            class="detailBtn btn__delete btn-none__border color__white bg__red"
            @click="delete_()"
          >
            <i class="fas fa-trash font-size__small"></i>&nbsp; Xóa văn bản
          </el-button>
          <el-button
            v-if="isEnableCC()"
            class="detailBtn detailBtnSecondary"
            @click="openCCDialog()"
          >
            <i class="fas fa-share-all font-size__small"></i>
            &nbsp;CC
          </el-button>

          <el-button
            v-if="isEnableGiaoViec"
            class="detailBtn detailBtnPrimary"
            @click="openGiaoViecDialog"
          >
            <i class="fas fa-fast-forward font-size__small"></i>
            Giao việc
          </el-button>

          <el-button
            v-if="isEnableExportTiepNhanVanBanReport"
            class="detailBtn detailBtnPrimary"
            @click="exportTiepNhanVanBanReport"
          >
            <i class="fas fa-fast-forward font-size__small"></i>
            Báo cáo tiếp nhận
          </el-button>
        </div>

        <div class="flex-row flex__right">
          <listIconAction :docId="id"/>
        </div>
      </div>
      <div v-else class="footer">
        <div class="flex-row flex__left form-button__action">
          <el-button class="detailBtn detailBtnPrimary" @click="restore">
            <i class="fas fa-undo font-size__small"></i>
            Phục hồi
          </el-button>

          <el-button class="detailBtn detailBtnAlert" @click="permanentDelete">
            <i class="fas fa-trash font-size__small"></i>
            Xóa văn bản
          </el-button>
        </div>
      </div>

      <transition name="slide">
        <history-docout
          ref="history-docout"
          v-show="tabHistory"
          :isEnableComment="true"
          :vbOutgoingDocId="id"
          @closeHistory="closeTabHistory"
        ></history-docout>
      </transition>

      <!-- dialog chon nguoi xu ly -->
      <DocOutSelectHandler
        v-if="isEnableDocOutSelectHandlerDialog"
        :isOpen="isOpenDocOutSelectHandlerDialog"
        :outgoingProcessId="userVbOutgoingProcessId"
        :quote="outgoingDoc.quote"
        :isAssistantSign = "isAssistantSign"
        :vbAttachmentId="vbAttachment.id"
        :publisherId="vbAttachment.publisherId"
        @closeDialog="isOpenDocOutSelectHandlerDialog = false"
        @closed="isEnableDocOutSelectHandlerDialog = false"
        @success="chuyenXuLiSuccess"
      />

      <!-- dialog ket thuc -->
      <DocOutKetThuc
        v-if="isEnableDocOutKetThucDialog"
        :docId="id"
        :isOpen="isOpenDocOutKetThucDialog"
        :vbOutgoingProcessId="userVbOutgoingProcessId"
        :vbAttachmentId="vbAttachment.id"
        @closeDialog="isOpenDocOutKetThucDialog = false"
        @dialogClosed="isEnableDocOutKetThucDialog = false"
        @success="banHanhSuccess"
      />

      <outgoingDocThuHoiDialog
        v-if="isEnableOutgoingDocThuHoiDialog"
        :isOpen="isOpenOutgoingDocThuHoiDialog"
        :vbOutgoingDocId="id"
        @closeDialog="isOpenOutgoingDocThuHoiDialog = false"
        @dialogClosed="isEnableOutgoingDocThuHoiDialog = false"
      />
      <!-- dialog tu choi -->

      <DocOutTuChoi
        v-if="isEnableDocOutTuChoiDialog"
        :docId="id"
        :isOpen="isOpenDocOutTuChoiDialog"
        :listImageChange="listImageChange"
        :outgoingProcessId="userVbOutgoingProcessId"
        :is-assistant-sign = "isAssistantSign"
        @closeDialog="isOpenDocOutTuChoiDialog = false"
        @closed="isEnableDocOutTuChoiDialog = false"
        @tuChoiSuccess="tuChoiSuccess"
      />
      <!-- dialog tu choi -->

      <DocOutTuChoiBanHanh
        v-if="isEnableDocOutTuChoiBHanhDialog"
        :docId="id"
        :isOpen="isOpenDocOutTuChoiBHanhDialog"
        @closeDialog="isOpenDocOutTuChoiBHanhDialog = false"
        @closed="isEnableDocOutTuChoiBHanhDialog = false"
        @tuChoiSuccess="tuChoiBHanhSuccess"
      />

      <!-- ban hành văn bản -->
      <BHanhDocOutDialog
        v-if="isEnableBHanhDocOut"
        :deptEditorId="outgoingDoc.deptEditorId"
        :docId="id"
        :docReceiverIds="docReceiverIds"
        :docStatus="outgoingDoc.status"
        :docTypeId="outgoingDoc.docTypeId"
        :isOpen="isOpenBHanhDocOut"
        :otherReceivePlaces="outgoingDoc.otherReceivePlaces"
        :publisherId="outgoingDoc.publisherId"
        :quote="outgoingDoc.quote"
        @closeDialog="isOpenBHanhDocOut = false"
        @closed="isEnableBHanhDocOut = false"
        @success="banHanhVanThuSuccess"
      />

      <!-- CC văn bản -->
      <CCDocOut
        v-if="isEnableDocOutCCDialog"
        :docId="id"
        :docTitle="outgoingDoc.quote"
        :isOpen="isOpenDocOutCCDialog"
        @closeDialog="isOpenDocOutCCDialog = false"
        @closed="isEnableDocOutCCDialog = false"
        @success="ccSuccess"
      />

      <outgoingDocProcessThuHoiDialog
        v-if="isEnableOutgoingDocProcessThuHoiDialog"
        :isOpen="isOpenOutgoingDocProcessThuHoiDialog"
        :vbOutgoingProcessId="userVbOutgoingProcessId"
        @closeDialog="isOpenOutgoingDocProcessThuHoiDialog = false"
        @dialogClosed="isEnableOutgoingDocProcessThuHoiDialog = false"
        @success="outGoingProcessThuHoiSuccess"
      />

      <outgoingDocThuHoiDialog
        v-if="isEnableOutgoingDocThuHoiDialog"
        :isOpen="isOpenOutgoingDocThuHoiDialog"
        :vbOutgoingDocId="id"
        @closeDialog="isOpenOutgoingDocThuHoiDialog = false"
        @dialogClosed="isEnableOutgoingDocThuHoiDialog = false"
      />

      <outgoingDocDBHThuHoiDialog
        v-if="isEnableOutgoingDocDBHThuHoiDialog"
        :isOpen="isOpenOutgoingDocDBHThuHoiDialog"
        :vbOutgoingDocId="id"
        @closeDialog="isOpenOutgoingDocDBHThuHoiDialog = false"
        @closed="isEnableOutgoingDocDBHThuHoiDialog = false"
      />
      <!--note in doc-->
      <DialogNoteInDocs
        v-if="isOpenNoteInDocDialog"
        :docId="id"
        :isAddSignature="false"
        :isOpen="isOpenNoteInDocDialog"
        :isWatchingNote="false"
        :vbAttachmentId="vbAttachment.id"
        @closeDialog="isOpenNoteInDocDialog = false"
        @closed="isEnableNoteInDocDialog = false"
        @finishNoteDoc="finishNoteDoc"
      />
      <!--add chu ky-->
      <DialogNoteInDocs
        v-if="isOpenAddSignatureDialog"
        :docId="id"
        :isAddSignature="true"
        :isOpen="isOpenAddSignatureDialog"
        :isWatchingNote="false"
        :vbAttachmentId="vbAttachment.id"
        @addSignatureSuccess="addSignatureSuccess"
        @closeDialog="isOpenAddSignatureDialog = false"
        @closed="isEnableAddSignatureDialog = false"
      />

      <task-create-dialog
        v-if="isEnableCreateJobDialog"
        :docId="id"
        :docType="DOC_TYPE.VB_DI"
        :isOpen="isOpenCreateJobDialog"
        :taskType="TASK_TASK_TYPE.GIAOVIEC"
        :viewType="JOB_INDEX_PAGE.ASSIGNER"
        @closeDialog="isOpenCreateJobDialog = false"
        @dialogClosed="isEnableCreateJobDialog = false"
        @success="createTaskSuccess"
      />

      <vb-outgoing-doc-sua-sai-bh-dialog-v2
        v-if="isEnableSuaSaiDialog && tenantCode === TENANT_CODE.VINATABA"
        :id="id"
        :isOpen="isOpenSuaSaiDialog"
        @closeDialog="isOpenSuaSaiDialog = false"
        @dialogClosed="isEnableSuaSaiDialog = false"
        @updateSuccess="suaSaiSuccess"
      />

      <vb-outgoing-doc-sua-sai-bh-dialog
        v-else-if="isEnableSuaSaiDialog"
        :id="id"
        :isOpen="isOpenSuaSaiDialog"
        @closeDialog="isOpenSuaSaiDialog = false"
        @dialogClosed="isEnableSuaSaiDialog = false"
        @updateSuccess="suaSaiSuccess"
      />

      <!--    hoang  cây thư mục start-->
      <tree-folder-dialog
        v-if="isEnableTreeFolderDialog"
        :accessoryType="accessoryType"
        :isOpen="isOpenDialogCreate"
        :vbId="id"
        @closeDialog="closeTreeFolderDialog"
        @closed="isEnableTreeFolderDialog"
        @success="createSuccess"
      />
      <!--   hoang   cây thư mục end-->
      <vbdi-list-version-dialog
        :docId="id"
        :isOpen="isOpenVbDiVersionDialog"
        :mode="mode"
        :title="'Phiên bản văn bản soạn thảo'"
        @closeDialog="isOpenVbDiVersionDialog=false"
      >
      </vbdi-list-version-dialog>

      <vbdi-list-version-lanh-dao-edit-dialog
        :docId="id"
        :isOpen="isOpenVbDiVersionLanhDaoEditDialog"
        :mode="mode"
        :title="'Phiên bản văn bản soạn thảo'"
        @closeDialog="isOpenVbDiVersionLanhDaoEditDialog=false"
      >
      </vbdi-list-version-lanh-dao-edit-dialog>
    </template>
  </detailTemplate>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import constants from "../../constants";
import {EventBus} from "../../event-bus.js";
import buildAttachmentURL from "../../filters/buildAttachmentURL.js";
import convertToLabelFilter from "../../filters/convertToLabelFilter";
import dateFormatter from "../../filters/dateFormatter";
import errorMessageFilter from "../../filters/errorMessageFilter";
import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
import attachmentService from "../../services/attachmentService";
import categoryViewService from "../../services/categoryViewService";
import docRelationService from "../../services/docRelationService";
import h from "../../services/h";
import menuConfigService from "../../services/menuConfigService";
import outgoingDocService from "../../services/outgoingDocService";
import utils from "../../services/utils";
import vbAttachmentTokenService from "../../services/vbAttachmentTokenService";
import vbDelegateInfoService from "../../services/vbDelegateInfoService";
import vbFlowInstanceService from "../../services/vbFlowInstanceService.js";
import vbOutgoingDocReceiversService from "../../services/vbOutgoingDocReceiversService";
import vbOutgoingProcessService from "../../services/vbOutgoingProcessService.js";
import vbStepService from "../../services/vbStepService";
import BreakWordSpan from "../adminstration/ketluan/break-word-span";
import FileTypeImage from "../common/FileTypeImage";
import handleRequestErrorMixin from "../handleRequestErrorMixin";
import TaskCreateDialog from "../job/create-job/task-create-dialog";
import BHanhDocOutDialog from "./components/BHanhDocOutDialog";
import CCDocOut from "./components/CCDocOut";
import DocOutKetThuc from "./components/DocOutKetThuc";
import DocOutTuChoi from "./components/DocOutTuChoi";
import DocOutTuChoiBanHanh from "./components/DocOutTuChoiBHanh";
import DocRelationsDetail from "./doc-relations-detail";
import HistoryDocout from "./History";
import PhieuYKienDetail from "./phieu-ykien-detail";
import VbOutgoingDocSuaSaiBhDialog from "./vb-outgoing-doc-sua-sai-bh-dialog";
import VbOutgoingDocSuaSaiBhDialogV2 from "./vb-outgoing-doc-sua-sai-bh-dialog-v2";
import VbdiDownloadFiles from "./vbdi-download-files";
import VbdiLuongxulyWrapper from "./vbdi-luongxuly-wrapper";
import CreateJobDialog from "../job/create-job/dialog-create";
import VbdiListVersionDialog from "./vbdi-list-version-dialog";
import VbdiListVersionLanhDaoEditDialog from "./vbdi-list-version-lanh-dao-edit-dialog";
import authenService from "../../services/authenService";
import VbdiLuongxulyAll from "../doc-out/vbdi-luongxuly-all.vue";
import uploadFileMixin from "../doc-in/uploadFileMixin";
import {mapActions} from "vuex";

export default {
  mixins: [handleRequestErrorMixin, vbAttachmentTokenMixin, uploadFileMixin],
  components: {
    VbdiLuongxulyAll,
    VbdiListVersionDialog,
    BreakWordSpan,
    VbOutgoingDocSuaSaiBhDialog,
    VbOutgoingDocSuaSaiBhDialogV2,
    VbdiListVersionLanhDaoEditDialog,
    TaskCreateDialog,
    HistoryDocout,
    VbdiLuongxulyWrapper,
    DocRelationsDetail,
    PhieuYKienDetail,
    VbdiDownloadFiles,
    CreateJobDialog,
    FileTypeImage,
    DocOutSelectHandler: () => import("./components/DocOutSelectHandler.vue"),
    DocOutKetThuc,
    DocOutTuChoi,
    DocOutTuChoiBanHanh,
    BHanhDocOutDialog,
    CCDocOut,
    detailTemplate: () => import("../common/detail.vue"),
    outgoingDocProcessThuHoiDialog: () =>
      import("./components/outgoingDocProcessThuHoiDialog"),
    outgoingDocThuHoiDialog: () =>
      import("./components/outgoingDocThuHoiDialog"),
    outgoingDocDBHThuHoiDialog: () =>
      import("./components/thuhoiBanHanhdialog"),
    VuePerfectScrollbar,
    listIconAction: () => import("./components/listIconActionDocs.vue"),
    DialogNoteInDocs: () => import("../common/noteDocs/index"),
    treeFolderDialog: () => import("../setting/quanLyTaiLieu/treeFolderDialog")
  },

  filters: {dateFormatter, buildAttachmentURL, convertToLabelFilter},

  data() {
    return {
      isUploadingDocFlag: null,
      isFileRemoved: false,
      // h- start
      mode: 'View',
      isOpenVbDiVersionDialog: false,
      isOpenVbDiVersionLanhDaoEditDialog: false,
      // vbIngoingDocCopy: null,
      // vbOutgoingDocCopy: null,
      isOpenDialogCreate: false,
      isEnableTreeFolderDialog: true,
      accessoryType: constants.QUAN_LY_TAI_LIEU.VB_DI,
      vbId: null,
      vbType: null,
      steeringTypeLabel: null,
      isOpenWatchingInternal: false,
      openFlowDetail: false,
      isLawDocument: null,
      DOC_RELATION_ATTACHED_TYPE: constants.DOC_RELATION_ATTACHED_TYPE,
      DOC_RELATION_OBJECT_TYPE: constants.DOC_RELATION_OBJECT_TYPE,
      TENANT_CODE: constants.TENANT_CODE,
      listImageChange: [],

      isOpenNoteInDocDialog: false,
      isEnableNoteInDocDialog: false,

      isOpenAddSignatureDialog: false,
      isEnableAddSignatureDialog: false,

      DOWNLOAD_OPTION: constants.DOWNLOAD_OPTION,
      settings: {maxScrollbarLength: 750},
      tabHistory: true,
      histories: [],
      docRelationTypes: [],

      outgoingDoc: {},
      vbAttachment: {},
      attachmentMetadata: null,
      receivedComment: null,
      signatureFile: null,
      referenceOutgoingAttachment: null,
      docRelations: [],
      docReceivers: null,
      agencies: null,
      receiveOtherDepts: null,
      docReceiverIds: [],
      vbCommentObjectType: constants.COMMENT_OBJECT_TYPE.VB_DI,
      LANH_DAO:constants.ROLE.CODE.LANH_DAO,
      userVbOutgoingProcess: null,
      flowInstance: null,
      flowInstanceId: null,
      flowInstances: [],
      flowId: null,
      stepId: null,
      step: null,
      delegateInfo: null,

      isOpenDocOutSelectHandlerDialog: false,
      isEnableDocOutSelectHandlerDialog: false,
      isOpenDocOutKetThucDialog: false,
      isEnableDocOutKetThucDialog: false,

      isOpenDocOutTuChoiDialog: false,
      isEnableDocOutTuChoiDialog: false,

      isOpenDocOutTuChoiBHanhDialog: false,
      isEnableDocOutTuChoiBHanhDialog: false,

      isOpenDocOutCCDialog: false,
      isEnableDocOutCCDialog: false,

      isOpenOutgoingDocProcessThuHoiDialog: false,
      isEnableOutgoingDocProcessThuHoiDialog: false,
      isOpenOutgoingDocThuHoiDialog: false,
      isEnableOutgoingDocThuHoiDialog: false,
      isOpenOutgoingDocDBHThuHoiDialog: false,
      isEnableOutgoingDocDBHThuHoiDialog: false,
      isOpenBHanhDocOut: false,
      isEnableBHanhDocOut: false,
      outgoingAttachmentURL: null, //link download nguyen goc;
      outgoingAttachmentForVanThuURL: null, //link download co chu ky khong co watermark;
      referenceOutgoingAttachmentURL: null, //link download co chu ky kem watermark;
      referenceOutgoingAttachmentURL2: null, //link download trc khi ban hanh co kem watermark;

      isOpenCreateJobDialog: false,
      isEnableCreateJobDialog: false,
      TASK_TASK_TYPE: constants.TASK_TASK_TYPE,
      JOB_INDEX_PAGE: constants.JOB_INDEX_PAGE,
      giaoViecMenuConfig: null,
      DOC_TYPE: constants.DOC_TYPE,
      OUTGOING_DOC_STATUS: constants.OUTGOING_DOC_STATUS,

      DA_KY: constants.ATTACHMENT_IS_SIGNED.DA_KY,

      isOpenSuaSaiDialog: false,
      isEnableSuaSaiDialog: false,
      isNotVinataba:true
    };
  },

  computed: {
    uploadAttachmentHeaders() {
      let header = {};
      let idToken = authenService.getIdToken();
      idToken && (header["Authorization"] = "Bearer " + idToken);
      // console.log("uploadFIleMixin uploadAttachmentHeaders " + idToken);
      let sessionId = authenService.getSessionId();
      sessionId && (header[constants.HTTP_HEADER_KEY.SESSION_ID] = sessionId);
      var userDeptRoleId = authenService.get(
        constants.STORAGE_KEY.USER_DEPT_ROLE_ID
      );
      userDeptRoleId &&
      (header[constants.HTTP_HEADER_KEY.USER_DEPT_ROLE_ID] = userDeptRoleId);
      return header;
    },

    uploadAttachmentAdditionalData() {
      return {
        objectType: constants.ATTACHMENT_OBJECT_TYPE.VB_DI,
        note: ""
      };
    },

    uploadAttachmentURL() {
      return constants.BASE_SERVICE_URL + "attachment/uploadFile";
    },

    //xác định xem văn bản có phải đã bị "xóa" không ?
    isAchievement() {
      return this.outgoingDoc.isAchievement;
    },

    globalConfigEditNode(){
      return authenService.getGlobalConfigEditNode()
    },

    signerName() {
      if (this.outgoingDoc) {
        return this.outgoingDoc.signerUserDeptRoleId
          ? `${this.outgoingDoc.signerName} (${
            this.outgoingDoc.signerPosName
          } ${this.outgoingDoc.signerDeptName})`
          : this.outgoingDoc.signerName;
      } else {
        return null;
      }
    },

    isKyNgoai() {
      return (
        this.outgoingDoc &&
        this.outgoingDoc.isKyNgoai === constants.OUTGOING_DOC.IS_KY_NGOAI.TRUE
      );
    },

    userVbOutgoingProcessId() {
      return this.$route.query.vbDocProcessId;
    },

    isAssistantSign(){
      return this.$route.query.isAssistantSign;
    },

    parentRoute() {
      return this.$route.path.split("/")[3];
    },

    userId() {
      return this.$store.getters.user.id;
    },

    roleCode() {
      return this.$store.getters.userDeptRole.roleCode;
    },

    deptId() {
      return this.$store.getters.userDeptRole.deptId;
    },

    tenantCode() {
      return this.$store.getters.userDeptRole.tenantCode;
    },

    deptCode() {
      return this.$store.getters.userDeptRole.deptCode;
    },

    publisherId() {
      return this.outgoingDoc ? this.outgoingDoc.publisherId : null;
    },

    /**
     * có thể thu hồi bởi người thực hiện chuyển xử lý;
     * @returns {boolean|outgoingDoc|{}}
     */
    canOutGoingProcessThuHoi() {
      return (
        (this.userVbOutgoingProcess &&
          this.userVbOutgoingProcess.status ==
          constants.OUTGOING_PROCESS_STATUS.DA_XU_LY &&
          this.outgoingDoc &&
          this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DANGXULI &&
          this.tenantCode !== "vinataba.com.vn")
        ||
        (this.userVbOutgoingProcess &&
          this.userVbOutgoingProcess.status ==
          constants.OUTGOING_PROCESS_STATUS.DA_XU_LY &&
          this.outgoingDoc &&
          this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DANGXULI &&
          this.tenantCode === "vinataba.com.vn" &&
          (this.deptCode === "TCT" || this.deptCode === "DU"))
      );
    },

    canOutGoingProcessThuHoiVinataba() {
      return (
        this.userVbOutgoingProcess &&
        this.userVbOutgoingProcess.status ==
        constants.OUTGOING_PROCESS_STATUS.DA_XU_LY &&
        this.outgoingDoc &&
        this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DANGXULI &&
        this.tenantCode === "vinataba.com.vn" &&
        (this.deptCode !== "TCT" || this.deptCode !== "DU")
      );
    },

    /**
     * có thể thu thồi bởi người ban hành;
     * @returns {boolean|outgoingDoc|{}}
     */
    canOutoingDocThuHoi() {
      return (
        (!this.userVbOutgoingProcessId &&
          this.outgoingDoc &&
          this.outgoingDoc.creatorId == this.userId &&
          constants.OUTGOING_DOC_STATUS.DANGXULI == this.outgoingDoc.status &&
          this.tenantCode !== "vinataba.com.vn" )
        ||
        (!this.userVbOutgoingProcessId &&
          this.outgoingDoc &&
          this.outgoingDoc.creatorId == this.userId &&
          constants.OUTGOING_DOC_STATUS.DANGXULI == this.outgoingDoc.status &&
          this.tenantCode === "vinataba.com.vn" && (this.deptCode === "TCT" || this.deptCode === "DU") )
      );
    },

    canOutoingDocThuHoiVinataba() {
      return (
        !this.userVbOutgoingProcessId &&
        this.outgoingDoc &&
        this.outgoingDoc.creatorId == this.userId &&
        constants.OUTGOING_DOC_STATUS.DANGXULI == this.outgoingDoc.status &&
        this.tenantCode === "vinataba.com.vn" &&
        (this.deptCode !== "TCT" || this.deptCode !== "DU")
      );
    },
    /**
     * thu hồi vb đã ban hành;
     * @returns {boolean|outgoingDoc|{}}
     */
    canOutoingDocDBHThuHoi() {
      return (
        ( this.roleCode == "vanthu" &&
          constants.OUTGOING_DOC_STATUS.DABANHANH == this.outgoingDoc.status &&
          this.tenantCode !== "vinataba.com.vn")
        ||
        ( this.roleCode == "vanthu" && constants.OUTGOING_DOC_STATUS.DABANHANH == this.outgoingDoc.status &&
          this.tenantCode === "vinataba.com.vn" && (this.deptCode === "TCT" || this.deptCode === "DU"))
      );
    },

    canOutoingDocDBHThuHoiVinataba() {
      return (
        this.roleCode == "vanthu" &&
        constants.OUTGOING_DOC_STATUS.DABANHANH == this.outgoingDoc.status &&
        this.tenantCode === "vinataba.com.vn" &&
        (this.deptCode !== "TCT" || this.deptCode !== "DU")
      );
    },

    isDaBanHanh() {
      return constants.OUTGOING_DOC_STATUS.DABANHANH == this.outgoingDoc.status;
    },

    id() {
      return this.$route.params.id;
    },
    docStatus() {
      return this.outgoingDoc ? this.outgoingDoc.status : null;
    },

    attachmenttURLForChuyenVien() {
      return [
        constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH,
        constants.OUTGOING_DOC_STATUS.DABANHANH
      ].indexOf(this.docStatus)
        ? this.referenceOutgoingAttachmentURL ||
        this.referenceOutgoingAttachmentURL2
        : this.referenceOutgoingAttachmentURL2;
    },

    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },

    isViewAsUyQuyen() {
      return (
        (this.delegateInfo &&
          this.delegateInfo.fromUserDeptRoleId == this.userDeptRoleId &&
          this.tenantCode !== "vinataba.com.vn")
        ||
        (this.delegateInfo &&
          this.delegateInfo.fromUserDeptRoleId == this.userDeptRoleId &&
          this.tenantCode === "vinataba.com.vn" && (this.deptCode === "TCT" || this.deptCode === "DU") )
      );
    },

    isViewAsUyQuyenVinataba() {
      return (
        this.delegateInfo &&
        this.delegateInfo.fromUserDeptRoleId == this.userDeptRoleId &&
        this.tenantCode === "vinataba.com.vn" &&
        (this.deptCode !== "TCT" || this.deptCode !== "DU")
      );
    },

    isViewTuChoi(){
      return (
        this.docStatus !== constants.OUTGOING_DOC_STATUS.TU_CHOI
      );
    },

    isEnableGiaoViec() {
      return (
        this.giaoViecMenuConfig !== null &&
        this.docStatus === constants.OUTGOING_DOC_STATUS.DABANHANH
      );
    },

    isEnableExportTiepNhanVanBanReport() {
      return (
        this.roleCode === constants.ROLE.CODE.VAN_THU &&
        this.outgoingDoc &&
        this.outgoingDoc.status === constants.OUTGOING_DOC_STATUS.DABANHANH
      );
    },

    isBanHanhTrucLienThong() {
      return this.agencies && this.agencies.length;
    },

    isBanHanhBanGiay() {
      return !!this.outgoingDoc.isBanHanhBanGiay;
    },

    isNotFileDinhKem() {
      return !!this.outgoingDoc.isNotFileDinhKem;
    }
  },

  mounted() {
    EventBus.$on("hieuChinhSuccess", options => {
      console.log('hieuChinhSuccess ... ')
      this.loadDocInfo();
      this.loadDocRelationsDetail();
    });
  },

  watch: {
    userVbOutgoingProcessId(newValue) {
      if (newValue) {
        this.loadUserVbOutgoingProcess();
      } else {
        this.userVbOutgoingProcess = null;
        this.flowInstanceId = null;
        this.stepId = this.userVbOutgoingProcess.stepId;
        this.step = null;
        this.flowInstance = null;
        this.flowId = null;
      }

      this.buildOutgoingAttachmentURL();
    },

    isOpenOutgoingDocProcessThuHoiDialog(newValue) {
      newValue && (this.isEnableOutgoingDocProcessThuHoiDialog = newValue);
    },
    isOpenOutgoingDocThuHoiDialog(newValue) {
      newValue && (this.isEnableOutgoingDocThuHoiDialog = newValue);
    },
    isOpenOutgoingDocDBHThuHoiDialog(newValue) {
      newValue && (this.isEnableOutgoingDocDBHThuHoiDialog = newValue);
    },
    isOpenDocOutKetThucDialog(newValue) {
      newValue && (this.isEnableDocOutKetThucDialog = newValue);
    },
    isOpenBHanhDocOut(newValue) {
      newValue && (this.isEnableBHanhDocOut = newValue);
    },
    isOpenDocOutSelectHandlerDialog(newValue) {
      newValue && (this.isEnableDocOutSelectHandlerDialog = newValue);
    },
    isOpenDocOutCCDialog(newValue) {
      newValue && (this.isEnableDocOutCCDialog = newValue);
    },
    isOpenDocOutTuChoiDialog(newValue) {
      newValue && (this.isEnableDocOutTuChoiDialog = newValue);
    },
    isOpenDocOutTuChoiBHanhDialog(newValue) {
      newValue && (this.isEnableDocOutTuChoiBHanhDialog = newValue);
    },
    isOpenNoteInDocDialog(newValue) {
      newValue && (this.isEnableNoteInDocDialog = newValue);
    },
    isOpenAddSignatureDialog(newValue) {
      newValue && (this.isEnableAddSignatureDialog = newValue);
    },
    isOpenSuaSaiDialog(newValue) {
      newValue && (this.isEnableSuaSaiDialog = newValue);
    },
    vbAttachment(newValue) {
      this.buildOutgoingAttachmentURL();
      this.buildReferenceOutgoingAttachmentURL2();
      this.loadAttachmentMetadata();
    },
    referenceOutgoingAttachment() {
      this.buildReferenceOutgoingAttachmentURL();
      this.buildOutgoingAttachmentForVanThuURL();
    },
    id() {
      this.loadDocInfo();
      this.loadReferenceOutgoingAttachment();
    },
    isOpenCreateJobDialog(newValue) {
      newValue && (this.isEnableCreateJobDialog = newValue);
    }
  },

  created() {
    this.loadCategories();
    this.loadDocInfo();
    this.loadReferenceOutgoingAttachment();
    this.initForGiaoViecButton();
    EventBus.$on('commentSent', this.getReceivedComment);
  },

  methods: {
    ...mapActions("outgoingDocs", ["emitEvent"]),

    validateAttachment() {
      if (!this.vbAttachment) {
        this.$message.error('Bạn cần phải có file đính kèm để thực hiện hành động này.');
        return false;
      }
      return true;
    },

    handleApproval() {
      if (this.validateAttachment()) {
        this.isOpenDocOutKetThucDialog = true;
      }
    },

    handleTransfer() {
      if (this.validateAttachment()) {
        this.isOpenDocOutSelectHandlerDialog = true;
      }
    },

    handleRejection() {
      if (this.validateAttachment()) {
        this.tuChoi();
      }
    },

    handleRejectionBanHanh() {
      if (this.validateAttachment()) {
        this.tuChoiBHanh();
      }
    },

    async openDocument(attachment) {
      const ext = attachment.fileExtention.toLowerCase();

      if (ext === 'doc' || ext === 'docx') {
        try {
          let token = this.getToken(attachment.id);

          if (!token) {
            token = await this.waitForToken(attachment.id);
          }

          if (token) {
            const url = buildAttachmentURL(token, {
              type: constants.DOWNLOAD_OPTION.TYPE.ORIGINAL
            });
            window.open(url, '_blank');
          } else {
            console.error("Token is null or undefined.");
          }
        } catch (error) {
          console.error("Error fetching token:", error);
        }
      } else if (ext === 'pdf') {
        this.isOpenNoteInDocDialog = true;
      }
    },

    // Phương thức chờ token
    async waitForToken(vbAttachmentId) {
      return new Promise((resolve, reject) => {
        const checkToken = () => {
          const token = this.getToken(vbAttachmentId);
          if (token) {
            resolve(token);
          } else {
            setTimeout(checkToken, 100);
          }
        };

        checkToken();
      });
    },

    buildMessageUploadOnlyPdf() {
      return errorMessageFilter({
        errorCode: "file.onlyAllowDocOutType"
      });
    },

    newValidateUploadFile(file, options, messageErr) {
      !options && (options = {});

      let fileExt = utils.getFileExt(file);

      //validate file type;
      let type = file.type;
      let acceptFileTypes = options.acceptFileTypes;
      if (!acceptFileTypes || !acceptFileTypes.length) {
        if (this.$store.getters.user.tenantCode !== 'vinataba.com.vn') {
          acceptFileTypes = constants.DEFAULT_ACCEPTED_CONTENT_TYPE;
        } else {
          acceptFileTypes = constants.DEFAULT_ACCEPTED_CONTENT_TYPE_VINATABA;
        }
      }
      let blackListExtensions =
        options.blackListExtensions || constants.DEFAULT_BLACK_LIST_EXTS;
      if (
        (acceptFileTypes.indexOf(type) === -1 &&
          acceptFileTypes.indexOf(
            constants.DEFAULT_ACCEPTED_CONTENT_TYPE_ALL
          ) === -1) ||
        blackListExtensions.indexOf(fileExt) !== -1
      ) {
        this.$message({
          message:
            messageErr ||
            errorMessageFilter({
              errorCode: "file.invalidFileType"
            }),
          type: "error"
        });
        return false;
      }
    },

    uploadAttachmentSuccess(vbAttachment) {
      this.vbAttachment = vbAttachment;
      this.form.attachmentId = vbAttachment.id;
      this.form.numberOfPage = vbAttachment.pageNumber;
      if (this.id) {
        this.wordEditSrc = constants.EDIT_ONLINE_SERVICE_URL + "editWord" + "?tenantCode=" + this.$store.getters.user.tenantCode + "&attachmentId=" + this.vbAttachment.id;
      } else {
        if (this.isCreateTemplateFile) {
          this.wordEditSrc = constants.EDIT_ONLINE_SERVICE_URL + "autoEditWord" + "?tenantCode=" + this.$store.getters.user.tenantCode + "&attachmentId=" + this.vbAttachment.id;
        } else {
          this.wordEditSrc = constants.EDIT_ONLINE_SERVICE_URL + "editWord" + "?tenantCode=" + this.$store.getters.user.tenantCode + "&attachmentId=" + this.vbAttachment.id;

        }
      }
    },

    onUploadSuccess(response) {
      this.isUploading = false;
      return new Promise(resolve => resolve(response));
    },

    removeUploadAttachment() {
      this.vbAttachment = null;
      this.wordEditSrc = null;
      this.form.attachmentId = null;
      this.form.attachmentFiles = [];
      this.isFileRemoved = true;
    },

    getReceivedComment(data){
      this.receivedComment = data;
    },
    confirmBanHanhBanGiay() {
      this.$confirm('Xác nhận đã ban hành văn bản giấy?', 'Thông báo', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() =>
        outgoingDocService.setBanHanhBanGiay(this.id)
        .then(() => {
          this.$message({
            type: 'success',
            message: 'Xác nhận ban hành văn bản giấy thành công!'
          })
          this.outgoingDoc.isBanHanhBanGiay = 1;
          EventBus.$emit(this.parentRoute, {});
        })
        .catch(() => {
          console.log('Lỗi set ban hành văn bản.')
        })
      ).catch(() => {

      });
    },

    confirmKhongCoFileDinhKem() {
      this.$confirm('Xác nhận không có tài liệu kèm?', 'Thông báo', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() =>
        outgoingDocService.setKhongCoFileDinhKem(this.id)
          .then(() => {
            this.$message({
              type: 'success',
              message: 'Xác nhận không có tài liệu kèm thành công!'
            })
            this.outgoingDoc.isNotFileDinhKem = 1;
            EventBus.$emit(this.parentRoute, {});
          })
          .catch(() => {
            console.log('Lỗi set ban hành văn bản.')
          })
      ).catch(() => {

      });
    },

    inPhieuTrinhKi(item) {
      let baseServiceURL = constants.BASE_SERVICE_URL;
      let reportUrl = constants.IN_PHIEU.VB_DI;
      console.log('docId', this.id)
      window.open(
        `${baseServiceURL}${reportUrl}?${utils.serialize({docId: this.id})}`,
      );
    },
    linkFolder() {
      this.isEnableCreateDialog = true;
      this.isOpenDialogCreate = true
      this.isEnableTreeFolderDialog = true
    },
    suaSaiSuccess(event) {
      this.isOpenSuaSaiDialog = false;
      this.backModel();
      EventBus.$emit(this.parentRoute, {});
    },
    permanentDelete() {
      utils
        .confirm(
          this.$confirm,
          errorMessageFilter({
            errorCode: "vbOutgoingDoc.permanentDelete.confirm"
          })
        )
        .then(() => {
          return outgoingDocService.permanentDelete(this.id).then(() => {
            this.$message.success(
              errorMessageFilter({
                errorCode: "vbOutgoingDoc.permanentDelete.success"
              })
            );
            this.commonAfterSuccess();
          });
        })
        .catch(error => this.commonHandleRequestError(error));
    },

    restore() {
      utils
        .confirm(
          this.$confirm,
          errorMessageFilter({
            errorCode: "vbOutgoingDoc.restore.confirm"
          })
        )
        .then(() => {
          return outgoingDocService.restore(this.id).then(() => {
            this.$message.success(
              errorMessageFilter({
                errorCode: "vbOutgoingDoc.restore.success"
              })
            );
            this.commonAfterSuccess();
          });
        })
        .catch(error => this.commonHandleRequestError(error));
    },

    initSteeringTypeLabel() {
      switch (this.outgoingDoc.steeringType) {
        case constants.STEERING_TYPE.KHONGPHAICHIDAO:
          this.steeringTypeLabel = errorMessageFilter({
            errorCode: "steeringType.label.khongphaichidao"
          });
          break;
        case constants.STEERING_TYPE.CHIDAO:
          this.steeringTypeLabel = errorMessageFilter({
            errorCode: "steeringType.label.chidao"
          });
          break;
        case constants.STEERING_TYPE.BAOCAOCHIDAO:
          this.steeringTypeLabel = errorMessageFilter({
            errorCode: "steeringType.label.baocaochidao"
          });
          break;
      }
    },

    delete_() {
      this.$confirm(
        `Bạn có muốn xóa văn bản "${this.outgoingDoc.quote}" ?`,
        "Thông báo",
        {
          confirmButtonText: "Xác nhận",
          cancelButtonText: "Hủy bỏ",
          type: "warning"
        }
      ).then(() => {
        outgoingDocService
          .deleteForVanThu(this.id)
          .then(() => {
            this.$message({
              message: "Xóa văn bản thành công",
              type: "success"
            });
            EventBus.$emit('loadCounting', '');
            this.commonAfterSuccess();
          })
          .catch(error => this.commonHandleRequestError(error));
      });
    },
    exportTiepNhanVanBanReport() {
      utils.exportReport(constants.REPORT.TIEPNHANVANBAN.REPORT_URL, {
        userDeptRoleId: this.userDeptRoleId,
        docId: this.id,
        docType: constants.DOC_TYPE.VB_DI
      });
    },

    initForGiaoViecButton() {
      return menuConfigService
        .findAll({
          userDeptRoleId: this.userDeptRoleId,
          menuCode: constants.MENU_LIST.CONGVIEC_GIAO,
          status: constants.MENU_CONFIG.STATUS.ACTIVE
        })
        .then(response => {
          let menuConfigs = response.data;
          return (this.giaoViecMenuConfig =
            menuConfigs && menuConfigs.length ? menuConfigs[0] : null);
        });
    },

    createTaskSuccess() {
      this.isOpenCreateJobDialog = false;
    },

    openGiaoViecDialog() {
      this.isOpenCreateJobDialog = true;
    },

    loadAttachmentMetadata() {
      if (this.vbAttachment && this.vbAttachment.id) {
        attachmentService
          .getAttachmentMetadata(this.vbAttachment.id)
          .then(response => {
            this.attachmentMetadata = response.data;
          });
      } else {
        this.attachmentMetadata = null;
      }
    },

    loadReferenceOutgoingAttachment() {
      attachmentService
        .findReferenceOutgoingAttachment(this.id)
        .then(response => (this.referenceOutgoingAttachment = response.data));
    },

    /**
     * link download cho chuyen vien sau khi ban hanh;
     */
    buildReferenceOutgoingAttachmentURL() {
      if (this.referenceOutgoingAttachment) {
        vbAttachmentTokenService
          .getTokenForReferenceOutgoingAttachment(
            this.referenceOutgoingAttachment.id
          )
          .then(response => {
            let token = response.data.token;
            this.referenceOutgoingAttachmentURL = buildAttachmentURL(token, {
              downloadFileURL:
              constants.DOWNLOAD_FILE_URL.REFERENCE_OUTGOING_URL
            });
          });
      } else {
        this.referenceOutgoingAttachmentURL = null;
      }
    },

    buildReferenceOutgoingAttachmentURL2() {
      if (this.vbAttachment) {
        vbAttachmentTokenService
          .getToken(this.vbAttachment.id)
          .then(response => {
            let token = response.data.token;
            this.referenceOutgoingAttachmentURL2 = buildAttachmentURL(token, {
              type: constants.DOWNLOAD_OPTION.TYPE.PDF,
              downloadFileURL: constants.DOWNLOAD_FILE_URL.OUTGOING_URL
            });
          });
      } else {
        this.referenceOutgoingAttachmentURL2 = null;
      }
    },

    /**
     * link download khong co watermark;
     */
    buildOutgoingAttachmentForVanThuURL() {
      if (this.referenceOutgoingAttachment) {
        vbAttachmentTokenService
          .getTokenForReferenceOutgoingAttachment(
            this.referenceOutgoingAttachment.id
          )
          .then(response => {
            let token = response.data.token;
            this.outgoingAttachmentForVanThuURL = buildAttachmentURL(token, {
              type: constants.DOWNLOAD_OPTION.TYPE.ORIGINAL,
              downloadFileURL: constants.DOWNLOAD_FILE_URL.DEFAULT_URL
            });
          });
      } else {
        this.outgoingAttachmentForVanThuURL = null;
      }
    },

    /**
     * link download nguyen goc;
     */
    buildOutgoingAttachmentURL() {
      if (this.vbAttachment) {
        vbAttachmentTokenService
          .getToken(this.vbAttachment.id)
          .then(response => {
            let token = response.data.token;
            this.outgoingAttachmentURL = buildAttachmentURL(token, {
              type: constants.DOWNLOAD_OPTION.TYPE.ORIGINAL,
              downloadFileURL: constants.DOWNLOAD_FILE_URL.DEFAULT_URL
            });
          });
      } else {
        this.outgoingAttachmentURL = null;
      }
    },

    addSignatureSuccess() {
      this.isOpenAddSignatureDialog = false;
      this.loadDocInfo();
      this.loadReferenceOutgoingAttachment();
    },

    populateListImageDoc(listImage) {
      let listImageModify = [];
      h.each(listImage, item => {
        if (item.isModify) {
          listImageModify.push({
            base64: item.base64,
            pageNumber: item.id,
            vbAttachmentId: this.vbAttachment.id
          });
        }
      });
      return listImageModify;
    },

    finishNoteDoc(listImage) {
      this.listImageChange = this.populateListImageDoc(listImage);
      this.tuChoi();
    },

    hieuChinhVb() {
      this.$router.push({
        name: "vbChoBanHanhHieuChinh",
        params: {
          userDeptRoleId: this.$route.params.userDeptRoleId,
          id: this.id
        },
        // query: this.$route.query
        query:{
          ...this.$route.query,
          vbAttachment: this.vbAttachment
        }
      });
    },

    suaSaiBanHanh() {
      this.isOpenSuaSaiDialog = true;
    },

    loadVbFlowInstance() {
      vbFlowInstanceService
        .findAll(
          {docId: this.id},
          {page: 0, size: 10, sort: "updateTime,asc"}
        )
        .then(response => {
          this.flowInstances = response.data.map((item, index) => {
            return {
              id: item.id,
              updateTime: item.updateTime,
              isActive: index == response.data.length - 1
            };
          });
        });
    },

    outGoingProcessThuHoiSuccess() {
      this.isOpenOutgoingDocProcessThuHoiDialog = false;
    },

    openTabHistory() {
      this.tabHistory = true;
    },

    closeTabHistory() {
      this.tabHistory = false;
    },

    getRelationTypeLabel(relationType) {
      var docRelationType = h.find(
        this.docRelationTypes,
        docRelationType => docRelationType.id == relationType
      );

      return docRelationType ? docRelationType.categoryName : null;
    },

    loadCategories() {
      h.each([constants.CATEGORY_GROUP_CODE.DOC_RELATION_TYPE], item => {
        categoryViewService
          .findAll({groupCode: item}, {page: 0, size: 1000})
          .then(response => {
            switch (item) {
              case constants.CATEGORY_GROUP_CODE.DOC_RELATION_TYPE:
                return (this.docRelationTypes = response.data);
            }
          });
      });
    },

    openCCDialog() {
      this.isOpenDocOutCCDialog = true;
    },

    tuChoi() {
      this.isOpenDocOutTuChoiDialog = true;
    },

    tuChoiBHanh() {
      this.isOpenDocOutTuChoiBHanhDialog = true;
    },

    banHanhSuccess(event) {
      this.isOpenDocOutKetThucDialog = false;
      this.userVbOutgoingProcess = event.vbOutgoingProcess;
      this.emitEvent({action: "ban-hanh-success"})
      this.backModel();
    },

    tuChoiSuccess() {
      this.isOpenDocOutTuChoiDialog = false;
      this.isOpenNoteInDocDialog = false;
      this.emitEvent({action: "tu-choi-success"});
      this.backModel();
    },

    tuChoiBHanhSuccess() {
      this.isOpenDocOutTuChoiBHanhDialog = false;
      this.backModel();
      EventBus.$emit(this.parentRoute, {});
    },

    banHanhVanThuSuccess() {
      this.isOpenBHanhDocOut = false;
      this.commonAfterSuccess();
    },

    ccSuccess() {
      this.isOpenDocOutCCDialog = false;
      this.backModel();
      this.commonAfterSuccess();
    },

    commonAfterSuccess() {
      EventBus.$emit(this.parentRoute, {});
      this.backModel();
    },

    docOutKetThucDialogClosed() {
      if (this.isBanHanhSuccess) {
        this.message(
          "Thông báo",
          "Ban hành văn bản thành công.",
          "success",
          4000
        );

        this.backModel();

        this.loadDocInfo();

        EventBus.$emit(this.parentRoute, {});
      }
    },

    docOutTuChoiDialogClosed() {
      if (this.isTuChoiSuccess) {
        this.message(
          "Thông báo",
          "Từ chối văn bản thành công.",
          "success",
          3000
        );

        this.backModel();

        this.loadDocInfo();

        EventBus.$emit(this.parentRoute, {});
      }
    },

    isEnableChuyenXuLi() {
      return (
        this.isChoXuLy() &&
        this.step &&
        this.step.posType != constants.STEP_POS_TYPE.KET_THUC &&
        this.step.posType != constants.STEP_POS_TYPE.BOTH
      );
    },

    isTuChoi() {
      return this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.TU_CHOI;
    },

    isChoXuLy() {
      return (
        this.userVbOutgoingProcess &&
        this.userVbOutgoingProcess.status ==
        constants.OUTGOING_PROCESS_STATUS.CHO_XU_LY
      );
    },

    isTaoMoi() {
      return (
        this.outgoingDoc &&
        this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.TAOMOI
      );
    },

    isEnableKetThuc() {
      return (
        this.isChoXuLy() &&
        this.step &&
        (this.step.posType == constants.STEP_POS_TYPE.KET_THUC ||
          this.step.posType == constants.STEP_POS_TYPE.BOTH)
      );
    },
    isEnableThuHoi() {
      return (
        this.isChoXuLy() &&
        this.step &&
        (this.step.posType == constants.STEP_POS_TYPE.KET_THUC ||
          this.step.posType == constants.STEP_POS_TYPE.BOTH)
      );
    },

    isEnableBanHanh() {
      return (
        (
          this.roleCode == "vanthu" &&
          this.outgoingDoc &&
          (this.outgoingDoc.status ==
            constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH ||
            this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DABANHANH) &&
          this.tenantCode !== "vinataba.com.vn"
        ) ||
        (
          this.roleCode == "vanthu" &&
            (this.deptCode === "TCT" || this.deptCode === "DU") &&
          this.outgoingDoc &&
          (this.outgoingDoc.status ==
            constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH ||
            this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DABANHANH) &&
          this.tenantCode === "vinataba.com.vn"
        )
      );
    },

    isEnableBanHanhVinataba() {
      return (
        this.roleCode === "vanthu" &&
          (this.deptCode !== "TCT" || this.deptCode !== "DU") &&
        this.outgoingDoc &&
        (this.outgoingDoc.status ==
          constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH ||
          this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DABANHANH) &&
        this.tenantCode === "vinataba.com.vn"
      );
    },
    isEnableTuChoiBanHanh() {
      return (
        this.flowInstances.length &&
        this.roleCode == "vanthu" &&
        this.outgoingDoc &&
        this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH
      );
    },

    isEnableHieuChinh() {
      return (
        this.roleCode == "vanthu" &&
        this.outgoingDoc &&
        this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH
      );
    },

    isEnableSuaSaiBanHanh() {
      return (
        (this.roleCode == "vanthu" &&
          this.outgoingDoc &&
          this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DABANHANH &&
          this.tenantCode !== "vinataba.com.vn")
        ||
        ((this.deptCode === "TCT" || this.deptCode === "DU") && this.roleCode == "vanthu" &&
          this.outgoingDoc &&
          this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DABANHANH &&
          this.tenantCode === "vinataba.com.vn")
      );
    },

    isEnableSuaSaiBanHanhVinataba() {
      return (
        (this.deptCode !== "TCT" || this.deptCode !== "DU") && this.roleCode == "vanthu" &&
        this.outgoingDoc &&
        this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DABANHANH &&
        this.tenantCode === "vinataba.com.vn"
      );
    },

    isEnableThemChuKy() {
      return (
        this.roleCode == "vanthu" &&
        this.attachmentMetadata &&
        this.outgoingDoc &&
        (this.outgoingDoc.status ==
          constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH ||
          this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DABANHANH)
      );
    },
    isEnableDelete() {
      return (
        this.outgoingDoc &&
        this.outgoingDoc.isKyNgoai == constants.OUTGOING_DOC.IS_KY_NGOAI.TRUE &&
        this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH &&
        this.outgoingDoc.publisherId ==
        this.$store.getters.userDeptRole.deptId &&
        this.$store.getters.userDeptRole.roleCode == constants.ROLE.CODE.VAN_THU
      );
    },

    isEnableCC() {
      return (
        this.outgoingDoc &&
        this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DABANHANH
      );
    },

    chuyenXuLiSuccess() {
      this.isOpenDocOutSelectHandlerDialog = false;

      this.message(
        "Thông báo",
        this.step && this.step.signType == 2 && (this.isAssistantSign  != 1 || this.isAssistantSign  == 1 && this.roleCode == constants.ROLE.CODE.LANH_DAO)
          ? "Ký số và chuyển xử lý văn bản thành công "
          : "Chuyển xử lý văn bản thành công ",
        "success",
        4000
      );

      EventBus.$emit(this.parentRoute, {});
      this.emitEvent({action: "chuyen-xl-success"})
      this.backListPage();
    },

    loadDocReceivers_(objectType) {
      return vbOutgoingDocReceiversService
        .findAll(
          {docId: this.id, objectType: objectType},
          {sort: "objectType", page: 0, size: 1000}
        )
        .then(response => response.data);
    },

    loadDocReceivers() {
      return this.loadDocReceivers_(constants.RECEIVER_OBJECT_TYPE.DONVI).then(
        docReceivers => {
          this.docReceivers = docReceivers;
          this.docReceiverIds = h.collect(
            docReceivers,
            docReceiver => docReceiver.objectId
          );
        }
      );
    },

    loadAgencies() {
      return this.loadDocReceivers_(
        constants.RECEIVER_OBJECT_TYPE.DONVI_TRUCLIENTHONG
      ).then(agencies => (this.agencies = agencies));
    },

    loadReceiveOtherDepts() {
      return this.loadDocReceivers_(
        constants.RECEIVER_OBJECT_TYPE.DONVI_BENNGOAI
      ).then(docReceivers => (this.receiveOtherDepts = docReceivers));
    },

    loadUserVbOutgoingProcess() {
      if (this.userVbOutgoingProcessId) {
        vbOutgoingProcessService
          .findById(this.userVbOutgoingProcessId)
          .then(response => {
            this.userVbOutgoingProcess = response.data;
            this.flowInstanceId = this.userVbOutgoingProcess.flowInstanceId;
            this.stepId = this.userVbOutgoingProcess.stepId;
            vbStepService
              .findById(this.stepId)
              .then(response => (this.step = response.data));
            if (this.userVbOutgoingProcess.delegateInfoId) {
              vbDelegateInfoService
                .findById(this.userVbOutgoingProcess.delegateInfoId)
                .then(response => (this.delegateInfo = response.data));
            } else {
              this.delegateInfo = null;
            }
            vbFlowInstanceService
              .findById(this.flowInstanceId)
              .then(response => {
                this.flowInstance = response.data;
                this.flowId = this.flowInstance.flowId;
              });
            // this.markAsRead();
          });
      }
    },

    loadDocRelationsDetail() {
      this.$refs.docRelationsNoAttachedDetail.loadRelationDocs();
      this.$refs.docRelationsAttachedDetail.loadRelationDocs();
      this.$refs.docRelationsAttachedLinkDetail.loadRelationDocs();
    },

    modelBack() {
      this.$router.back();
    },

    getSecurityClass(id) {
      return constants.HIGH_LEVELS_SECURITY_IDS.indexOf(id) != -1
        ? "lv1"
        : "lv4";
    },

    getPriorityClass(id) {
      const startsWithHighPriority = constants.HIGH_LEVELS_PIORITY_IDS.some(priorityId => id.startsWith(priorityId));
      return startsWithHighPriority ? "lv1" : "lv4";
    },

    backModel() {
      this.$router.push({name: this.parentRoute, params: this.$route.params});
    },

    maskAsRead() {
      outgoingDocService
        .maskAsRead(this.id, this.userVbOutgoingProcessId)
        .catch(error => this.commonHandleRequestError(error));
    },

    loadDocInfo() {
      outgoingDocService
        .findById(this.id)
        .then(response => (this.outgoingDoc = response.data))
        .then(() => {
          this.isLawDocument =
            this.outgoingDoc.isLawDocument === constants.TRUE;
          this.initSteeringTypeLabel();
        })
        .then(() => this.maskAsRead());

      attachmentService
        .findAll({
          objectId: this.id,
          objectType: constants.ATTACHMENT_OBJECT_TYPE.VB_DI
        })
        .then(response => {
          if (response.data && response.data.length) {
            if(this.globalConfigEditNode)
            {
              this.vbAttachment = response.data.filter(item => item.fileExtention === 'pdf')[0];
            }
            else{
              this.vbAttachment = response.data[0];
            }

          }
        });

      attachmentService
        .findAll(
          {
            objectId: this.id,
            objectType:
            constants.ATTACHMENT_OBJECT_TYPE.FILE_BAN_HANH_CO_CHU_KY_PDF
          },
          {sort: "createTime,desc", page: 0, size: 1}
        )
        .then(response => {
          if (response.data && response.data.length) {
            this.signatureFile = response.data[0];
          } else this.signatureFile = null;
        });

      docRelationService.findAll({objectId: this.id}).then(response => {
        this.docRelations = response.data;
      });

      this.loadUserVbOutgoingProcess();
      this.loadDocReceivers();
      this.loadReceiveOtherDepts();
      this.loadAgencies();
      this.loadVbFlowInstance();
    },

    backListPage() {
      let namePageBack = this.$route.path.split("/");
      this.$router.push({
        name: `${namePageBack[3]}`,
        query: this.$route.query,
        params: this.$route.params
      });
    },
    createSuccess() {
      this.isOpenDialogCreate = false;
    },
    closeCreateDialog() {
      this.isOpenDialogCreate = false;
    },
    closeTreeFolderDialog() {
      this.isEnableTreeFolderDialog = false
    },

    isNotTuChoiInList() {
      if (this.$refs["history-docout"] && this.$refs["history-docout"].histories) {
        const histories = this.$refs["history-docout"].histories;
        const validActions = ['lanhDaoTuChoi', 'tuChoiTiepNhan'];
        if (Array.isArray(histories) && histories.length > 0) {
          return histories.some(history => validActions.includes(history.actionName));
        }
      }
      return false;
    },

    isBanHanhToi() {
      if (this.$refs["history-docout"] && this.$refs["history-docout"].histories) {
        const histories = this.$refs["history-docout"].histories;

        if (Array.isArray(histories) && histories.length > 0 && histories[0].actionName) {
          const firstHistoryAction = histories[0].actionName;
          return firstHistoryAction.includes('banHanhV2');
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    TuChoi() {
      if (this.$refs["history-docout"] && this.$refs["history-docout"].histories) {
        const histories = this.$refs["history-docout"].histories;

        if (Array.isArray(histories) && histories.length > 0 && histories[0].actionName) {
          const firstHistoryAction = histories[0].actionName;
          return firstHistoryAction.includes('lanhDaoTuChoi') || firstHistoryAction.includes('tuChoiTiepNhan');
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    isSuaSai(){
      if (this.$refs["history-docout"] && this.$refs["history-docout"].histories) {
        const histories = this.$refs["history-docout"].histories;

        if (Array.isArray(histories) && histories.length > 0 && histories[0].actionName) {
          const firstHistoryAction = histories[0].actionName;
          return firstHistoryAction.includes('vbOutgoingDoc.suaSai');
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    isThuHoi(){
      if (this.$refs["history-docout"] && this.$refs["history-docout"].histories) {
        const histories = this.$refs["history-docout"].histories;

        if (Array.isArray(histories) && histories.length > 0 && histories[0].actionName) {
          const firstHistoryAction = histories[0].actionName;
          return firstHistoryAction.includes('thuHoi') ||  firstHistoryAction.includes('thuHoiBanHanhV2') ||  firstHistoryAction.includes('thuHoiBanHanh') ;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    isDocReceiversNull() {
      return !this.docReceivers || !this.docReceivers.length;
    },


  },

  destroyed() {
    EventBus.$off("hieuChinhSuccess");
    EventBus.$off('commentSent', this.getReceivedComment);
    document.removeEventListener("keyup", this.escapeKeyListener);
  }
};
</script>

<style scoped>
.overflow-menu {
  position: relative;

  overflow-x: scroll;
  top: 4px;
  padding: 3px;
  margin: 3px;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/Detail.vue